import React, { useEffect, useState } from 'react'
import { Modal, Tooltip } from 'antd'
import { Button, ColumnProps, Table } from '@digital/ui'
import { downloadArquivo, getArquivosDocumento, viewArquivo } from '@app/api/sas/sasDocumentoOrdemCompra'
import { GetFileExtension, imageFormats } from '@app/helpers'
import { Visibility } from '@app/components'
import { convertUTCtoLocal, dateTimeFormat } from '@app/helpers/dateTimeFormats'
import moment from 'moment'


interface Props {
    sasDocumentoOrdemComraId: string
}

const ModalHistoricoArquivo = (props: Props) => {
    const { sasDocumentoOrdemComraId } = props;
    const [exibirModal, setExibirModal] = useState(false)
    const [arquivos, setArquivos] = useState([])

    useEffect(() => {
        if (exibirModal === true) {
            getArquivosDocumento(sasDocumentoOrdemComraId).then(data => {
                if (data) setArquivos(data)
            })
        }
    }, [exibirModal])

    const columns = () => {
        let columns: ColumnProps<any>[] = [];

        columns.push({
            title: 'Arquivo',
            dataIndex: 'nome',
            // width: '40%'
        })

        columns.push({
            title: 'Status',
            className: "td-centralizado",
            dataIndex: 'status',
            width: '15%'
        })

        columns.push({
            title: 'inclusão',
            className: 'td-centralizado',
            dataIndex: 'dataCriacao',
            width: '10%',
            render: (text, record, index) => convertUTCtoLocal(moment(record.dataCriacao)).toLocaleString(),
        })

        columns.push({
            title: 'Versão',
            className: "td-centralizado",
            dataIndex: 'versao',
            width: '10%'
        })

        columns.push({
            title: 'Ações',
            dataIndex: '',
            width: '5%',
            render(text, record, index) {
                return <>
                    <Tooltip title="Download Arquivo">
                        <Button
                            icon="ui-download"
                            type="link"
                            onClick={() => {
                                downloadArquivo(
                                    record.id,
                                    record.nome
                                );
                            }}
                        />
                    </Tooltip>
                    <>
                        {GetFileExtension(record.nome) === "pdf" ||
                            imageFormats.includes(
                                GetFileExtension(record.nome)
                            ) ? (
                            <Tooltip title="Visualizar Arquivo">
                                <Button
                                    icon="files-view_file"
                                    type="link"
                                    onClick={() => {
                                        viewArquivo(
                                            record.id,
                                            record.nome
                                        );
                                    }}
                                />
                            </Tooltip>
                        ) : (
                            <></>
                        )}
                    </>
                </>
            },
        })


        return columns;
    }

    return (
        <>
            <Tooltip title="Visualizar Histórico do Documento">
                <Button
                    onClick={() => {
                        setExibirModal(true)
                    }}
                    icon="messaging-attach"
                />
            </Tooltip>
            <Visibility
                visible={exibirModal}
            >
                <Modal
                    title="Histórico de Arquivos"
                    width="680px"
                    visible={exibirModal}
                    onCancel={() => setExibirModal(false)}
                    footer={null}
                >
                    <Table
                        dataSource={arquivos}
                        columns={columns()}
                        rowKey="id"
                        pagination={false}
                    />
                </Modal>
            </Visibility>
        </>
    )
}

export default ModalHistoricoArquivo